export default { sha: 'c222e16afe039d65809f70dda10f3f0d96576446', buildNumber: 'undefined' }
